import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _OutputAuthorizationRequest, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { OutputAuthorizationItem } from "../../../../../Inventories-Warehouses/OutputAuthorizationRequest/OutputAuthorizationItem/OutputAuthorizationItem";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

type SignedApprove = {
    IDAccount: number;
    Approved: boolean;
    Date: string;
};

export const SOLAUTSAL002 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};

    const { instance, bean, setBean } = useDataBean(_OutputAuthorizationRequest)

    const activos = JSON.parse(props.JSONFixedAssetItem || "[]");
    const productos = JSON.parse(props.JSONProduct || "[]");
    const [response, setResponse] = useState<Resp>({
        Aprove: "",
        Obs: ""
    })

    const modal = useModal("Productos/Activos Solicitados", MODAL_LG);

    useEffect(() => {
        if (props.IDOutputAuthorizationRequest) {
            instance.getOutputAuthorizationRequest(props.IDOutputAuthorizationRequest).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props.IDOutputAuthorizationRequest])

    const onExportMap = () => {
        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Solicitud": `${response.Aprove == "true" ? "Aprobada" : "Rechazada"}`,
                "Jusitificación": response.Obs,
            })
        );
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ Approved: response.Aprove })
        }
    }


    const updateData = () => {
        if (response.Obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setResponse({ ...response, Aprove: "" })
            return;
        }

        const signedList: SignedApprove[] = JSON.parse(bean.JSONSignedApproveList || "[]");

        const newSign: SignedApprove = {
            IDAccount: _single.getAccountID(),
            Approved: response.Aprove === "true",
            Date: _single.getCurrenDate(),
        };

        signedList.push(newSign);

        const x = {
            ...bean,
            State: response.Aprove == "true" ? 101 : 102,
            IDAccountLastAprove: _single.getAccountID(),
            DescriptionResponse: response.Obs,
            JSONSignedApproveList: JSON.stringify(signedList)
        };

        instance.updateOutputAuthorizationRequest(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }


    useEffect(() => {
        if (response.Aprove !== "") {
            updateData();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Aprove: `${app}` }));
    }

    return (
        <div className="container-fluid">

            <div className="card mb-3">
                <div className="card-body">

                    <div className="mb-3">
                        <label className="fw-bold text-muted">Justificación</label>
                        <div className="bg-light border rounded p-3 mt-1">
                            {props.Description}
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <label className="fw-bold text-muted">Periodo</label>
                            <div className="mt-1">
                                <div><strong>Desde:</strong> {props.FromDate}</div>
                                <div><strong>Hasta:</strong> {props.UptoDate}</div>
                            </div>
                        </div>

                        <div className="col-md-6 text-end">
                            <BasicButton
                                icon=""
                                clase="primary"
                                eventClick={() => modal.open()}
                            >
                                Ver Productos/Activos
                            </BasicButton>
                        </div>
                    </div>

                </div>
            </div>

            <div className="mb-3">
                <label className="fw-bold">Observaciones</label>
                <textarea
                    className="form-control mt-1"
                    rows={3}
                    value={response.Obs}
                    onChange={(e) =>
                        setResponse(prev => ({ ...prev, Obs: e.target.value }))
                    }
                />
            </div>

            <div className="d-flex justify-content-between mt-4">

                <BasicButton disable={!bean.IDOutputAuthorizationRequest} icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>

                <BasicButton disable={!bean.IDOutputAuthorizationRequest} icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>

            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <OutputAuthorizationItem _OutputAutorization={props} />
            </Modal>

        </div>
    );
}